<button [title]="buttonTitle" #button class="mdc-icon-button material-icons" [disabled]="disabled">
  <ng-content></ng-content>
</button>